import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { EmailInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsEmailWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_EMAIL;
    return /*#__PURE__*/ React.createElement(EmailInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-email-wut.js.map